<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
